import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "../../lib/utils";

export function Switch({ className, ...props }) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#60a5fa]/30 disabled:cursor-not-allowed disabled:opacity-40 data-[state=checked]:bg-[#3b82f6] data-[state=unchecked]:bg-[var(--soft-fill-strong)] border border-[var(--border-ui)]",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className="pointer-events-none block h-3.5 w-3.5 rounded-full bg-white shadow-sm transition-transform duration-200 data-[state=checked]:translate-x-[18px] data-[state=unchecked]:translate-x-[3px]"
      />
    </SwitchPrimitive.Root>
  );
}
